import { State, City, Country } from 'country-state-city';

const getCountryOptions = () =>
  Country.getAllCountries().map((c) => ({ value: c.isoCode, label: c.name }));

const getStateOptions = (countryCode = 'IN') =>
  State.getStatesOfCountry(countryCode).map((s) => ({ value: s.isoCode, label: s.name }));

const getCityOptions = (countryCode = 'IN', stateCode = '') => {
  if (!stateCode) return [];
  return City.getCitiesOfState(countryCode, stateCode).map((c) => ({ value: c.name, label: c.name }));
};

export const masterDataFields = {
  departments: [
    { name: 'departmentId', label: 'Department ID', type: 'text', required: true },
    { name: 'name', label: 'Department Name', type: 'text', required: true },
    { name: 'description', label: 'Description', type: 'textarea' },
    { name: 'status', label: 'Status', type: 'select', options: [{ value: 'active', label: 'Active' }, { value: 'inactive', label: 'Inactive' }], defaultValue: 'active' },
  ],
  vendors: [
    { name: 'vendorId', label: 'Vendor ID', type: 'text', required: true },
    { name: 'vendorName', label: 'Vendor Name', type: 'text', required: true },
    { name: 'contactPerson', label: 'Contact Person', type: 'text' },
    { name: 'email', label: 'Email', type: 'email' },
    { name: 'phone', label: 'Phone', type: 'tel' },
    { name: 'address', label: 'Address', type: 'textarea' },
    { name: 'state', label: 'State', type: 'select', options: getStateOptions('IN'), dependsOn: 'country' },
    { name: 'country', label: 'Country', type: 'select', options: getCountryOptions(), defaultValue: 'IN' },
    { name: 'pincode', label: 'Pincode', type: 'text' },
       { name: 'gstin', label: 'GSTIN', type: 'text', pattern: '^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$', title: 'Enter valid GSTIN format (15 characters)' },
    { name: 'description', label: 'Description', type: 'textarea' },
    { name: 'status', label: 'Status', type: 'select', options: [{ value: 'active', label: 'Active' }, { value: 'inactive', label: 'Inactive' }], defaultValue: 'active' },
  ],
  customers: [
    { name: 'customerId', label: 'Customer ID', type: 'text', required: true },
    { name: 'customerName', label: 'Customer Name', type: 'text', required: true },
    { name: 'contactPerson', label: 'Contact Person', type: 'text' },
    { name: 'email', label: 'Email', type: 'email' },
    { name: 'phone', label: 'Phone', type: 'tel' },
    { name: 'address', label: 'Address', type: 'textarea' },
    { name: 'state', label: 'State', type: 'select', options: getStateOptions('IN'), dependsOn: 'country' },
    { name: 'country', label: 'Country', type: 'select', options: getCountryOptions(), defaultValue: 'IN' },
    { name: 'pincode', label: 'Pincode', type: 'text' },
    { name: 'gstin', label: 'GSTIN', type: 'text', pattern: '^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$', title: 'Enter valid GSTIN format (15 characters)' },
    { name: 'description', label: 'Description', type: 'textarea' },
    { name: 'status', label: 'Status', type: 'select', options: [{ value: 'active', label: 'Active' }, { value: 'inactive', label: 'Inactive' }], defaultValue: 'active' },
  ],
  brands: [
    { name: 'brandId', label: 'Brand ID', type: 'text', required: true },
    { name: 'brandName', label: 'Brand Name', type: 'text', required: true },
    { name: 'description', label: 'Description', type: 'textarea' },
    { name: 'status', label: 'Status', type: 'select', options: [{ value: 'active', label: 'Active' }, { value: 'inactive', label: 'Inactive' }], defaultValue: 'active' },
  ],
  categories: [
    { name: 'categoryId', label: 'Category Code', type: 'text', required: true, pattern: '^[A-Z]{2,5}$', title: '2-5 uppercase letters (e.g., IT, FURN, VEH)' },
    { name: 'categoryName', label: 'Category Name', type: 'text', required: true },
    { name: 'description', label: 'Description', type: 'textarea' },
    { name: 'status', label: 'Status', type: 'select', options: [{ value: 'active', label: 'Active' }, { value: 'inactive', label: 'Inactive' }], defaultValue: 'active' },
  ],
  subcategories: [
    { name: 'subCategoryId', label: 'Sub-Category ID', type: 'text', required: true },
    { name: 'subCategoryName', label: 'Sub-Category Name', type: 'text', required: true },
    { name: 'categoryId', label: 'Parent Category', type: 'select', required: true, options: [] }, // Hydrated dynamically by original categories state
    { name: 'serializationType', label: 'Asset Tracking Method', type: 'select', required: true, options: [], defaultValue: 'serialized', helpText: 'Choose how assets in this sub-category should be tracked' }, // Hydrated dynamically from SVL Collection
    { name: 'depreciation', label: 'Depreciation Method', type: 'select', required: false, options: [], defaultValue: '', helpText: 'Optional — select a depreciation method to inherit it on assets in this sub-category' }, // Hydrated dynamically from SVL Collection
    { name: 'usefulLife', label: 'Useful Life (Years)', type: 'number', required: false, min: 1, max: 50, helpText: 'Applies to Straight-Line Method (SLM) — optional' },
    { name: 'depreciationRate', label: 'Depreciation Rate (%)', type: 'number', required: false, min: 0, max: 100, step: 0.1, helpText: 'Applies to Written Down Value Method (WDV) — optional' },
    { name: 'description', label: 'Description', type: 'textarea' },
    {
  name: 'taggingRequired',
  label: 'Tagging Required',
  type: 'select',
  required: false,
  options: [
    { value: 'no',  label: 'No — tag verification not required' },
    { value: 'yes', label: 'Yes — prompt Admin/Auditor to verify tag on QR scan' },
  ],
  defaultValue: 'no',
  helpText: 'When enabled, Admin and Auditor users will be prompted to photograph and verify the physical tag when scanning this asset\'s QR code.',
},
    { name: 'status', label: 'Status', type: 'select', options: [{ value: 'active', label: 'Active' }, { value: 'inactive', label: 'Inactive' }], defaultValue: 'active' },
  ],
  locations: [
    { name: 'locationCode', label: 'Location Code', type: 'text', required: true },
    { name: 'locationName', label: 'Location Name', type: 'text', required: true },
    { name: 'address', label: 'Address', type: 'textarea' },
    { name: 'country', label: 'Country', type: 'select', options: getCountryOptions(), defaultValue: 'IN' },
    { name: 'state', label: 'State', type: 'select', options: getStateOptions('IN'), dependsOn: 'country' },
    { name: 'city', label: 'City', type: 'select', options: getCityOptions('IN', ''), dependsOn: 'state' },
    { name: 'pinCode', label: 'Pin Code', type: 'text', pattern: '^[0-9]{6}$', title: 'Enter 6-digit pin code' },
    { name: 'status', label: 'Status', type: 'select', options: [{ value: 'active', label: 'Active' }, { value: 'inactive', label: 'Inactive' }], defaultValue: 'active' },
  ],
};

export const getTableColumns = (type) => {
  const columns = {
    departments: [
      { key: 'departmentId', label: 'Department ID' },
      { key: 'name', label: 'Department Name' },
      { key: 'description', label: 'Description' },
      { key: 'status', label: 'Status', render: (item) => (<span className={`status ${String(item.status).toLowerCase() === 'active' ? 'active' : 'inactive'}`}>{item.status}</span>) },
    ],
    vendors: [
      { key: 'vendorId', label: 'Vendor ID' },
      { key: 'vendorName', label: 'Vendor Name' },
      { key: 'contactPerson', label: 'Contact Person' },
      { key: 'email', render: (item) => item.email ? (<a href={`mailto:${item.email}?subject=Vendor Inquiry - ${item.vendorName}&body=Dear ${item.contactPerson || 'Sir/Madam'},%0D%0A%0D%0A[Please write your message here]%0D%0A%0D%0ABest regards,%0D%0AAdmin Team`} className="email-link" title="Send email to vendor">{item.email}</a>) : '-' },
      { key: 'phone', label: 'Phone', render: (item) => item.phone ? (<a href={`tel:${item.phone}`} className="phone-link" title="Call vendor">{item.phone}</a>) : '-' },
      { key: 'state', label: 'State', render: (item) => { if (item.state && item.country) { const s = State.getStateByCodeAndCountry(item.state, item.country); return s ? s.name : item.state; } return item.state || '-'; } },
      { key: 'country', label: 'Country', render: (item) => { if (item.country) { const c = Country.getCountryByCode(item.country); return c ? c.name : item.country; } return '-'; } },
           { key: 'pincode', label: 'Pincode' },
      { key: 'gstin', label: 'GSTIN' },
      { key: 'status', label: 'Status', render: (item) => (<span className={`status ${String(item.status).toLowerCase() === 'active' ? 'active' : 'inactive'}`}>{item.status}</span>) },
    ],
    customers: [
      { key: 'customerId', label: 'Customer ID' },
      { key: 'customerName', label: 'Customer Name' },
      { key: 'contactPerson', label: 'Contact Person' },
      { key: 'email', render: (item) => item.email ? (<a href={`mailto:${item.email}?subject=Customer Inquiry - ${item.customerName}&body=Dear ${item.contactPerson || 'Sir/Madam'},%0D%0A%0D%0A[Please write your message here]%0D%0A%0D%0ABest regards,%0D%0AAdmin Team`} className="email-link" title="Send email to customer">{item.email}</a>) : '-' },
      { key: 'phone', label: 'Phone', render: (item) => item.phone ? (<a href={`tel:${item.phone}`} className="phone-link" title="Call customer">{item.phone}</a>) : '-' },
      { key: 'state', label: 'State', render: (item) => { if (item.state && item.country) { const s = State.getStateByCodeAndCountry(item.state, item.country); return s ? s.name : item.state; } return item.state || '-'; } },
      { key: 'country', label: 'Country', render: (item) => { if (item.country) { const c = Country.getCountryByCode(item.country); return c ? c.name : item.country; } return '-'; } },
      { key: 'pincode', label: 'Pincode' },
      { key: 'gstin', label: 'GSTIN' },
      { key: 'status', label: 'Status', render: (item) => (<span className={`status ${String(item.status).toLowerCase() === 'active' ? 'active' : 'inactive'}`}>{item.status}</span>) },
    ],
    brands: [
      { key: 'brandId', label: 'Brand ID' },
      { key: 'brandName', label: 'Brand Name' },
      { key: 'description', label: 'Description' },
      { key: 'status', label: 'Status', render: (item) => (<span className={`status ${String(item.status).toLowerCase() === 'active' ? 'active' : 'inactive'}`}>{item.status}</span>) },
    ],
    categories: [
      { key: 'categoryId', label: 'Category Code', render: (item) => (<span className="code">{item.categoryId}</span>) },
      { key: 'categoryName', label: 'Category Name' },
      { key: 'description', label: 'Description' },
      { key: 'status', label: 'Status', render: (item) => (<span className={`status ${String(item.status).toLowerCase() === 'active' ? 'active' : 'inactive'}`}>{item.status}</span>) },
    ],
    subcategories: [
      { key: 'subCategoryId', label: 'Sub-Category ID' },
      { key: 'subCategoryName', label: 'Sub-Category Name' },
      { key: 'categoryId', label: 'Category', render: (item) => (<span className="category-code">{item.categoryId}</span>) },
      {
        key: 'serializationType',
        label: 'Tracking Method',
        render: (item) => {
          const t = String(item.serializationType || 'serialized').toLowerCase();
          const isNonSerialized = t === 'non-serialized';
          return (
            <span className={`badge ${isNonSerialized ? 'bg-warning text-dark' : 'bg-info'}`}>
              {isNonSerialized ? 'Quantity Based' : 'Individual Tracking'}
            </span>
          );
        }
      },
      {
        key: 'depreciation',
        label: 'Depreciation',
        render: (item) => {
          const dep = item.depreciation;
          if (!dep || dep === '' || dep === 'None') return <span style={{ color: '#6c757d' }}>—</span>;
          const isSLM = dep === 'straight-line' || dep === 'SLM';
          return (
            <span className={`badge ${isSLM ? 'bg-success' : 'bg-primary'}`}>
              {isSLM ? 'SLM' : 'WDV'}
            </span>
          );
        }
      },
      {
        key: 'usefulLife',
        label: 'Useful Life',
        render: (item) => {
          const isSLM = item.depreciation === 'straight-line' || item.depreciation === 'SLM';
          return isSLM && item.usefulLife ? `${item.usefulLife} Yrs` : '-';
        }
      },
      {
        key: 'depreciationRate',
        label: 'Depr. Rate',
        render: (item) => {
          const isWDV = item.depreciation === 'written-down-value' || item.depreciation === 'WDV';
          return isWDV && item.depreciationRate ? `${item.depreciationRate}%` : '-';
        }
      },
      { key: 'description', label: 'Description' },
      { key: 'status', label: 'Status', render: (item) => (<span className={`status ${String(item.status).toLowerCase() === 'active' ? 'active' : 'inactive'}`}>{item.status}</span>) },
    ],
    locations: [
      { key: 'locationCode', label: 'Location Code' },
      { key: 'locationName', label: 'Location Name' },
      { key: 'address', label: 'Address' },
      { key: 'country', label: 'Country', render: (item) => { if (item.country) { const c = Country.getCountryByCode(item.country); return c ? c.name : item.country; } return '-'; } },
      { key: 'state', label: 'State', render: (item) => { if (item.state && item.country) { const s = State.getStateByCodeAndCountry(item.state, item.country); return s ? s.name : item.state; } return item.state || '-'; } },
      { key: 'city', label: 'City' },
      { key: 'pinCode', label: 'Pin Code' },
      { key: 'status', label: 'Status', render: (item) => (<span className={`status ${String(item.status).toLowerCase() === 'active' ? 'active' : 'inactive'}`}>{item.status}</span>) },
    ],
  };
  return columns[type] || [];
};

export { getStateOptions, getCountryOptions, getCityOptions };